export const OUTLOOK_MODULE_NAME = "outlook_module";

export const outlookModuleMenuItem = {
  icon: "envelope",
  path: "/outlook",
};

export const outlookModuleRoutes = [
  {
    path: "outlook",
    name: "OutlookMail",
    components: {
      default: () => import("./pages/OutlookMail.vue"),
    },
    meta: {
      title: "Outlook",
      requiresAuth: true,
      requiresModule: OUTLOOK_MODULE_NAME,
    },
  },
  {
    path: "outlook/oauth/callback",
    name: "OutlookOAuthCallback",
    components: {
      default: () => import("./pages/OutlookOAuthCallback.vue"),
    },
    meta: {
      title: "Outlook",
      requiresAuth: true,
      requiresModule: OUTLOOK_MODULE_NAME,
    },
  },
];

export default {
  moduleName: OUTLOOK_MODULE_NAME,
  routes: outlookModuleRoutes,
  menuItem: outlookModuleMenuItem,
};
